import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState, getDataFromState, Profile } from '@trade-platform/ui-shared';
import { select, Store } from '@ngrx/store';
import { debounceTime, take } from 'rxjs/operators';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'aix-need-assistance-card',
    templateUrl: './need-assistance-card.html',
    styleUrls: ['./need-assistance-card.scss'],
    standalone: true,
    imports: [AsyncPipe]
})
export class AixNeedAssistanceComponent {
    store = inject<Store<AppState>>(Store);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    profile$: Observable<Profile>;
    supportEmail: string;
    supportPhone: string;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const store = this.store;

        const state$ = store.pipe(select(state => state.profile));
        this.profile$ = getDataFromState(state$).pipe(debounceTime(50));
        this.profile$.pipe(take(1)).subscribe((profile: Profile) => {
            this.supportEmail =
                profile.organization?.supportEmail || this.environment.contactDetails.supportEmail;
            this.supportPhone =
                profile.organization?.supportPhoneNumber ||
                this.environment.contactDetails.supportPhone;
        });
    }
}
